/* eslint-disable react-hooks/exhaustive-deps */
import { useApolloClient } from "@apollo/client";
import Pagination from "@mostrans/web-components/components/base/Pagination";
import {
  Box,
  Card,
  CardContent,
  Dialog,
  Grid,
  useMediaQuery,
  useTheme,
  Zoom,
} from "@mui/material";
import { isEmpty } from "lodash";
import React, { useEffect, useState } from "react";
import { useRecoilValue } from "recoil";
import { getOpportunityIsActive } from "../../graphql/query";
import {
  filterJobAtom,
  filterKotaforJobsAtom,
  isLoggedInSelector,
  userDataSelector,
} from "../../shared/globalStates";
import "../Card/Card.css";
import LoadingFallback from "../General/LoadingFallback";
import ModalDetailOpportunity from "../ModalDetailOpportunity/ModalDetailOpportunity";

const Cards = ({ search }) => {
  const [data, setData] = useState([]);
  const [loading, setLoading] = useState(true);
  const filterJobs = useRecoilValue(filterJobAtom);
  const [filter, setFilter] = useState();
  const [currentPage, setCurrentPage] = useState(0);
  const [nextPage, setNextPage] = useState(12);
  const isLoggedIn = useRecoilValue(isLoggedInSelector);
  const filterKota = useRecoilValue(filterKotaforJobsAtom);
  const userData = useRecoilValue(userDataSelector);
  const client = useApolloClient();
  const theme = useTheme();
  const fullScreen = useMediaQuery(theme.breakpoints.down("md"));
  const [open, setOpen] = useState(false);
  const [id, setID] = useState([]);
  const handleOpen = (data) => {
    setID(data.id);
    setOpen(true);
  };



  useEffect(() => {
    if (isLoggedIn) {
      getOpportunityIsActive(client, parseInt(userData.id)).then(setData);
    } else {
      getOpportunityIsActive(client).then(setData);
    }
  }, []);

  useEffect(() => {
    if (!isEmpty(data)) {
      if (!isEmpty(search)) {
        setCurrentPage(0);
        setNextPage(12);
        const filter = data.filter((e) => {
          return (
            e.title.toLowerCase().indexOf(search) !== -1 ||
            e.Location.nama.toLowerCase().indexOf(search) !== -1 ||
            e.Division.division.toLowerCase().indexOf(search) !== -1
          );
        });
        setFilter(filter);
      } else if (!isEmpty(filterJobs) || !isEmpty(filterKota)) {
        const filter = data.filter((e) => {
          return (
            Object.values(filterJobs).includes(e.Division.division) ||
            filterKota === e.Location.nama ||
            Object.values(filterJobs).includes(e.job_level)
          );
          // return (
          //   filterJobs.includes(e.Division.division) ||
          //   filterKota === e.Location.nama ||
          //   filterJobs.includes(e.job_level)
          // );
        });
        setFilter(filter);
      } else {
        setFilter(data);
      }
    }
    setLoading(false);
  }, [data, search, filterJobs, filterKota, setLoading, loading]);

  const handleClose = () => setOpen(false);

  return loading ? (
    <Box
      sx={{
        margin: "auto",
        justifyContent: "center",
        textAlign: "center",
      }}
    >
      <LoadingFallback />
      {/* <CircularProgress /> */}
    </Box>
  ) : (
    <React.Fragment>
      <Dialog
        fullScreen={fullScreen}
        open={open}
        onClose={handleClose}
        aria-labelledby="modal-card-details"
        closeAfterTransition
      >
        <Zoom in={open} style={{ transitionDelay: open ? "50ms" : "0ms" }}>
          <div>
            <ModalDetailOpportunity
              id={id}
              open={open}
              setOpen={setOpen}
              handleClose={handleClose}
              opportunityId={id}
              setdata={setData}
            />
          </div>
        </Zoom>
      </Dialog>

      <Grid container>
        {filter?.length > 0 ? (
          filter.slice(nextPage - 12, (currentPage + 1) * 12).map((result) => (
            <Grid item xl={4} lg={6} md={6} sm={6} xs={12} key={result.id}>
              <Card
                className="shadow-soft-s4-hover"
                variant="outlined"
                sx={{
                  height: "360px",
                  marginX: "20px",
                  marginY: "15px",
                  cursor: "pointer",
                  borderRadius: "10px",
                }}
                onClick={() => handleOpen(result)}
              >
                <CardContent
                  style={{
                    height: "100%",
                    position: "relative",
                    padding: "0",
                  }}
                >
                  <div className="header-content" style={{ margin: "1rem" }}>
                    <div className="header-title">
                      <h5>{result.title}</h5>
                    </div>
                    <div className="sub-header">
                      <span
                        className="material-icons text-primary-main"
                        style={{ marginRight: "5px" }}
                      >
                        work
                      </span>
                      <b
                        className="text-secondary"
                        style={{ fontSize: "12px", marginRight: "15px" }}
                      >
                        {result.job_level}
                      </b>
                      <span className="material-icons text-primary-main">
                        location_on
                      </span>
                      <b
                        className="text-secondary"
                        style={{ fontSize: "12px", marginRight: "15px" }}
                      >
                        {result.Location.nama}
                      </b>
                    </div>
                  </div>
                  <div></div>
                  <hr style={{ margin: "10px 0", width: "100%" }} />
                  <div
                    className="body-content"
                    style={{ margin: "1rem", height: "50%" }}
                  >
                    <div className="requirements font-size-small">
                      <h6 style={{ padding: "5px 0" }}>Description</h6>
                      <div>
                        <p
                          className="wrapper__description"
                          dangerouslySetInnerHTML={{
                            __html: result.description,
                          }}
                        />
                      </div>
                    </div>
                  </div>
                  <div
                    className="footer-contents"
                    style={{
                      width: "100%",
                      display: "flex",
                      justifyContent: "space-between",
                      position: "absolute",
                      bottom: "15px",
                      flexDirection: "column",
                    }}
                  >
                    <hr
                      style={{
                        margin: "0",
                        width: "100%",
                      }}
                    />
                    <div
                      className="main__content"
                      style={{
                        display: "flex",
                        padding: "16px",
                        alignItems: "center",
                      }}
                    >
                      <h6
                        className="text-primary-main"
                        style={{ verticalAlign: "text-bottom", width: "100%" }}
                      >
                        View complete job details
                      </h6>
                      <span className="material-icons text-primary-main">
                        east
                      </span>
                    </div>
                  </div>
                </CardContent>
              </Card>
            </Grid>
          ))
        ) : (
          <Box
            sx={{
              margin: "auto",
              justifyContent: "center",
              textAlign: "center",
            }}
          >
            Sorry, the job list is not available
          </Box>
        )}
        <Grid item xl={12} lg={12} md={12} sm={12} xs={12}>
          <div
            className="pagination"
            style={{
              margin: "20px 0",
              justifyContent: "center",
              display: "flex",
            }}
          >
            <Pagination
              style={{ padding: "500px" }}
              totalData={filter?.length}
              currentPage={currentPage}
              onPageChange={({ page }) => {
                setCurrentPage(page);
                setNextPage(page * 12);
              }}
              rowsPerPage={12}
              showResult={false}
              showFirstLastButton={true}
              showRowsPerPageOptions={false}
              showPageNumber={true}
            />
          </div>
        </Grid>
      </Grid>
    </React.Fragment>
  );
};

export default Cards;
